<div fxFlex="100">
  <div fxLayout="column" style="padding-left:15px; padding-right:15px;" fxLayoutGap="2%">

    <div fxLayout="row" fxFlex="100" fxLayoutAlign="center center">
      <app-greeting [user]="currentUser"></app-greeting>
    </div>

    <!--     Notification & Consents Container-->
    <div fxLayout="row wrap">
      <div fxLayout="column" fxFlex.lt-md="100" fxFlex.gt-sm="49.5"
           style="border:1px solid lightgray; height:350px; border-radius: 5px;" ngStyle.gt-sm="margin-right:1%;"
           class="mat-elevation-z6">

        <div fxLayout="row" fxLayoutAlign="center center" style="margin-top:10px; margin-bottom:10px;">Ανακοινώσεις
        </div>

        <mat-divider></mat-divider>

      </div>
      <div fxFlex.lt-md="100" fxFlex.gt-sm="49.5"
           style="border:1px solid lightgray; height:350px; border-radius:5px;" ngStyle.lt-md="margin-top:1%;"
           class="mat-elevation-z6">

        <div fxLayout="row" fxLayoutAlign="center center" style="margin-top:10px; margin-bottom:10px;">Ολοκληρωμένες
          Αιτήσεις
        </div>
        <mat-divider></mat-divider>

        <ng-container
          *ngIf="!loadingNotifications && !loadingCompletedConsents && !loadingChildren then CompletedConsentsComponent else LoadingCompletedConsents"></ng-container>

        <ng-template #CompletedConsentsComponent>
          <app-completed-consents [user]="currentUser" [children]="children"></app-completed-consents>
        </ng-template>

        <ng-template #LoadingCompletedConsents>
          <app-loading></app-loading>
        </ng-template>

      </div>
    </div>
    <!--    -->

    <!--    Children Container-->
    <div fxLayout="row wrap" style="border:1px solid lightgray; border-radius: 5px; margin-bottom: 250px;" class="mat-elevation-z6">
      <div *ngFor="let child of children" fxFlex.lt-md="100" fxFlex.gt-sm="48"
           style="border:1px solid lightblue; height:150px; margin-left:1%; margin-right:1%; margin-bottom:1%; margin-top:1%; padding:10px;"
           fxLayout="column" fxLayoutGap="10px">

        <div fxLayout="row" fxFlex="100">

          <div fxLayout="column" fxFlex="50" fxLayoutAlign="center center center">
            <div fxLayout="row" fxLayoutAlign="start center center">
              Όνομα: {{child.firstName}}
            </div>

            <div fxLayout="row">
              Επώνυμο: {{child.lastName}}
            </div>

            <div fxLayout="row">
              Ημερομηνία Γέννησης: {{child.birthday}}
            </div>
          </div>


          <div fxLayout="column" fxFlex="50" fxLayoutAlign="center center center">
            <div fxLayout="row" fxLayoutAlign="center center center">
              <label [matBadge]="childNotification(child).toString()" [matBadgeHidden]="showNotificationToChild(child)"
                     matBadgeColor="warn" matBadgePosition="above after" class="notificationButton"></label>
            </div>
            <div style="margin-top:3%;" fxLayout="row"
                 fxLayoutAlign="center center">{{notificationMessage(child)}}</div>
          </div>

        </div>


      </div>
      <!--      <div fxFlex.lt-md = "100" fxFlex.gt-sm="49.5"-->
      <!--           style="border:1px solid lightgray; height:150px;" class="mat-elevation-z6" ngStyle.lt-md="margin-top:1%;" ngStyle.gt-sm="margin-top:1%;"></div>-->

      <!--      <div fxFlex.lt-md = "100" fxFlex.gt-sm="49.5"-->
      <!--           style="border:1px solid lightgray; height:150px; margin-bottom:1%;" class="mat-elevation-z6" ngStyle.gt-sm="margin-right:1%; margin-top:1%;"></div>-->
      <!--      <div fxFlex.lt-md = "100" fxFlex.gt-sm="49.5"-->
      <!--           style="border:1px solid lightgray; height:150px; margin-bottom:1%;" class="mat-elevation-z6" ngStyle.lt-md="margin-top:1%;" ngStyle.gt-sm="margin-top:1%;"></div>-->

    </div>
    <!---->
  </div>
</div>


